var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLotsuite = function SvgLotsuite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "inner",
    x: 148.73,
    y: 164,
    width: 710.77,
    height: 710.77
  })), /*#__PURE__*/React.createElement("path", {
    className: "outer",
    d: "M874.5.5h-724a150,150,0,0,0-150,150v724a150,150,0,0,0,150,150h724a150,150,0,0,0,150-150v-724A150,150,0,0,0,874.5.5Zm-401,749h-311v-475h128v371h183Zm199-323.78q14.44,11,78.42,40.26,61.36,27.6,85.23,59.26T860,605q0,44.16-22.41,78.41T773,736.62q-42.21,19-99,19-47.41,0-79.55-6.66T527.5,725.75V611.45a381.12,381.12,0,0,0,76.31,29.38q39.6,10.56,72.73,10.56,28.58,0,41.89-9.91T731.74,616a28,28,0,0,0-5.36-17q-5.36-7.31-17.21-14.78T646,553.65q-46.44-21.1-69.65-40.91T542,467.28q-11.21-25.65-11.2-60.72,0-65.58,47.73-102.28t131.18-36.7q73.71,0,150.34,34.1l-39.29,99q-66.57-30.51-115-30.52-25,0-36.36,8.77T658,400.71Q658,414.67,672.48,425.72Z",
    transform: "translate(-0.5 -0.5)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLotsuite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lotsuite.092cfb05.svg";
export { ForwardRef as ReactComponent };